<template>
    <div :id="id">
        <div class="dropdown position-relative" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle nav-link" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <i class="fa fa fa-user text-dark mr-2"></i>
            </a>
            <div class="dropdown-menu small m-0 p-0 mw-100">
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="$ceres.urls.myAccount" class="list-group-item small text-dark d-xl-none d-md-none"><i class="fa far fa-user mr-1 mr-xl-4" aria-hidden="true"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a :href="$ceres.urls.myAccount" class="list-group-item small text-dark d-none d-md-inline-block order-3 order-xl-2"><i class="fa far fa-bags-shopping mr-1 mr-xl-3" aria-hidden="true"></i> {{ $translate("modeherz::HeaderClient.myAccountOrders") }}</a>
                    <a :href="$ceres.urls.myAccount+'?myaCfg=1'" class="list-group-item small text-dark d-none d-md-inline-block order-2 order-xl-3"><i class="fa far fa-user mr-1 mr-xl-4" aria-hidden="true"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" class="list-group-item small d-none d-xl-inline-block order-4" v-logout><i class="fa fa-sign-out text-dark mr-3" aria-hidden="true"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn">
            <a :id="id + '-open-login-modal'" class="nav-link" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); createRegisterModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.loginMyAccount')">
                <i class="fa fal fa-user text-dark mr-2"></i>
                <span class="d-inline d-xl-none" style="font-weight:500">{{ $translate("Ceres::Template.loginMyAccount") }}</span>
            </a>
        </div>
    </div>
</template>

<script>
import ValidationService from "../../../services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        },
      id:{
          type: String,
          default: "login-change"
      }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
